import React from 'react';
import { Bee } from './Illustrations';

const INTERIOR_1 = '/images/peek-inside.png';

export default function PeekInside() {
  return (
    <section
      data-testid="peek-inside-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-[#FBE8EE]/40 via-[#FBF7F2] to-[#FBF7F2]" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="text-center max-w-2xl mx-auto">
          <p className="font-accent text-2xl text-[#8D68B2]">A peek inside</p>
          <h2 className="font-heading text-4xl md:text-5xl text-[#24385C] mt-2 leading-tight">
            Every feeling has a seat.
          </h2>
          <p className="mt-6 font-body text-lg text-[#24385C]/80">
            Meet the whole colorful cast — because whatever you&rsquo;re feeling today,
            you&rsquo;re in very good company.
          </p>
        </div>

        <div className="mt-14 max-w-2xl mx-auto relative">
          <div className="absolute inset-0 -m-6 bg-[#B88ACB]/20 blob-shape-2" />
          <div className="relative bg-white rounded-[28px] p-3 md:p-4 shadow-[0_25px_60px_-25px_rgba(36,56,92,0.35)] rotate-[-1deg] hover:rotate-0 transition-transform duration-500">
            <img
              src={INTERIOR_1}
              alt="Interior page: I make space for all my feelings — they don't ever have to hide."
              className="w-full h-auto rounded-2xl block"
              loading="lazy"
            />
          </div>
          <Bee className="absolute -top-8 -right-4 w-20 animate-float-tiny" />
        </div>

        <div className="mt-12 text-center">
          <p className="font-accent text-3xl text-[#8D68B2]">
            &ldquo;I make space for all my feelings —
            they don&rsquo;t ever have to hide.&rdquo;
          </p>
          <p className="mt-2 font-body text-sm text-[#24385C]/60">
            — from <em>The Feelings Bench</em>
          </p>
        </div>
      </div>
    </section>
  );
}
